import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useMutation } from '@grandvisionhq/graphql';
import { useIntl } from '@grandvisionhq/state';
import DELETE_SHOPPING_LIST from '../operations/mutations/delete-shopping-list.js';

const useDeleteShoppingList = ({ removeLocalShoppingList , localShoppingListId  })=>{
    const { locale  } = useIntl();
    const [mutation, { data: data1 , loading , error  }] = useMutation(DELETE_SHOPPING_LIST, {
        onCompleted: (data)=>{
            // This is for anonymous users: we need to remove the shopping list from local storage for anonymous users
            // once they have removed all of their items and the deletion of the list in CommerceTools was successful.
            if (data.deleteShoppinglist.success && localShoppingListId) {
                removeLocalShoppingList();
            }
        },
        context: {
            forwardHeaders: {
                'Accept-Language': locale
            }
        }
    });
    const deleteShoppingList = React.useCallback(function() {
        var _ref = swcHelpers.asyncToGenerator(function*({ shoppinglistId  }) {
            yield mutation({
                variables: {
                    shoppinglistId
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), [
        mutation
    ]);
    var _success;
    return {
        success: (_success = data1 === null || data1 === void 0 ? void 0 : data1.deleteShoppinglist.success) !== null && _success !== void 0 ? _success : null,
        loading,
        error,
        deleteShoppingList
    };
};

export { useDeleteShoppingList };
//# sourceMappingURL=use-delete-shopping-list.js.map
